import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall, PenTool, Code2, Rocket, Wrench } from 'lucide-react';
const steps = [{
  icon: <PhoneCall size={28} data-id="element-284" />,
  title: '1. Discovery Call',
  desc: 'We discuss your business goals, target audience, and vision for the website to ensure we are a perfect fit.'
}, {
  icon: <PenTool size={28} data-id="element-285" />,
  title: '2. Design & Planning',
  desc: 'I create a preview so you can see exactly how the site will look before final look'
}, {
  icon: <Code2 size={28} data-id="element-286" />,
  title: '3. Development',
  desc: 'I build your custom website using modern, fast, and secure web technologies, ensuring it looks great on all devices.'
}, {
  icon: <Rocket size={28} data-id="element-287" />,
  title: '4. Launch',
  desc: 'After rigorous testing and your final approval, we push the site live and connect your custom domain.'
}, {
  icon: <Wrench size={28} data-id="element-288" />,
  title: '5. Ongoing Support',
  desc: 'I provide reliable hosting, regular updates, and ongoing maintenance to keep your site running perfectly.'
}];
export function Process() {
  return <section id="process" className="py-24 bg-black border-y border-white/5 relative overflow-hidden" data-id="element-289">
      <div className="container mx-auto px-6 md:px-12" data-id="element-290">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-291">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-292">
            A Simple, <span className="text-gradient" data-id="element-293">Transparent Process</span>
          </h2>
          <p className="text-lg text-[#FFFFFF]" data-id="element-294">
            No confusing jargon or hidden steps. Just a straightforward path
            from our first hello to your successful launch.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-295">
          {/* Connecting Line */}
          <div className="absolute left-[28px] md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-blue-600/50 via-blue-500/50 to-blue-600/50 md:-translate-x-1/2" data-id="element-296"></div>

          <div className="space-y-12" data-id="element-297">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`flex flex-col md:flex-row gap-8 items-start md:items-center relative ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-298">
                {/* Center Node */}
                <div className="absolute left-0 md:left-1/2 w-14 h-14 rounded-full bg-[#111118] border-4 border-blue-500 flex items-center justify-center text-blue-400 md:-translate-x-1/2 z-10 shadow-[0_0_15px_rgba(59,130,246,0.3)]" data-id="element-299">
                  {step.icon}
                </div>

                {/* Content */}
                <div className={`ml-20 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pl-16' : 'md:pr-16 md:text-right'}`} data-id="element-300">
                  <div className="bg-[#111118] p-6 rounded-2xl border border-white/5 hover:border-blue-500/30 transition-colors" data-id="element-301">
                    <h3 className="text-xl font-bold text-white mb-3 font-heading" data-id="element-302">
                      {step.title}
                    </h3>
                    <p className="leading-relaxed text-[#FFFFFF]" data-id="element-303">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}